import React, { useEffect, useState } from 'react'
import { isNumber } from 'underscore';

const PlusMinusInputForOrderReturnReq = (props) => {
    const { force_default_quantity } = props;
    const { disable_validation_check } = props;
    const { QtyMult, QtyMin, QtyShipped } = props;
    const [tempQuantity, setTempQuantity] = useState(false);
    const [valid_quantity_message, set_valid_quantity_message] = useState(false);

    const setQuantityWithAction = async (action) => {
        async function fetchHere() {
            let QtyMultHere = QtyMult;
            let q = 0;
            if (action === 'minus') {
                q = tempQuantity - QtyMultHere
            }
            if (action === 'plus') {
                q = tempQuantity + QtyMultHere
            }
            if (q < 1) {
                q = 0;
            }
            if (q > 0) {
                await manageTempQuantity(q);
            }
        }

        fetchHere()
    };
    useEffect(() => {
        async function fetchHere() {
            if (force_default_quantity !== undefined) {
                setTempQuantity(force_default_quantity);
            }
        }
        fetchHere();
    }, [force_default_quantity]);

    const manageTempQuantity = (valueIn) => {
        valueIn = parseInt(valueIn);
        if (isNaN(valueIn)) {
            valueIn = 0;
        }
        setTempQuantity(valueIn);
        if (valueIn !== false) {
            if (props.onChange) {
                if (disable_validation_check !== undefined && disable_validation_check === true) {
                    props.onChange(valueIn)
                    return;
                }
                validateBeforeSendToMainCheckFailing(valueIn);
                props.onChange(valueIn)
            }
        }
    }

    const validateBeforeSendToMainCheckFailing = (valueIn) => {
        if (QtyMin && valueIn < QtyMin) {
            set_valid_quantity_message("Invalid Quantity");
            return false;
        }
        if (QtyMin && QtyShipped && valueIn > QtyShipped) {
            set_valid_quantity_message("Return to Quantity can not be greater than Shipped Quantity");
            return false;
        }
        if (QtyMult && valueIn % QtyMult !== 0) {
            return false;
        }
        if (valid_quantity_message !== false) {
            set_valid_quantity_message("")
        }
        return true;
    };

    return (
        <>
            <div className="quantity w-auto clearfix ">
                <div className={`quantity-picker ${valid_quantity_message != '' && ' error'}`}>
                    <div className="bs5 input-group flex-nowrap border-0">
                        <span className="bs5 input-group-prepend flex-nowrap">
                            <button type="button"
                                onClick={async () => {
                                    await setQuantityWithAction('minus');
                                }}
                                className="bs5 btn btn-outline-secondary btn-number br-0">
                                <span className="fa quantity-picker-minus" />
                            </button>
                        </span>
                        <input type="text" className={`form-control input-number bg-white`}
                            placeholder={QtyMult !== undefined ? QtyMult : 0}
                            value={tempQuantity}
                            onChange={(e) => {
                                let n = parseInt(e.target.value);
                                if (!isNumber(n)) {
                                    n = false;
                                }
                                if (n !== false) {
                                    manageTempQuantity(n)
                                }
                            }}
                        />
                        <span className="bs5 input-group-append flex-nowrap">
                            <button type="button"
                                onClick={async () => {
                                    await setQuantityWithAction('plus');
                                }}
                                className="bs5 btn btn-outline-secondary btn-number bl-0">
                                <span className="fa quantity-picker-plus" />
                            </button>
                        </span>
                    </div>
                </div>
                {valid_quantity_message != '' &&
                    <span className="mandatory">{valid_quantity_message}</span>
                }
            </div>
        </>
    );
}

export default PlusMinusInputForOrderReturnReq
